import { css } from 'styled-components';

const Fontface = css`
  /* Google Fonts moved to css @import at top-level (fontImports.css) */

  /* -------------------- CDN/개인 호스팅: @font-face 방식 -------------------- */

  /* Acta Display */
  @font-face {
    font-family: 'Acta Display';
    src: url('//db.onlinewebfonts.com/t/8426a04cc01b52b246b8a8e01d168356.eot');
    src: url('//db.onlinewebfonts.com/t/8426a04cc01b52b246b8a8e01d168356.eot?#iefix')
        format('embedded-opentype'),
      url('//db.onlinewebfonts.com/t/8426a04cc01b52b246b8a8e01d168356.woff2')
        format('woff2'),
      url('//db.onlinewebfonts.com/t/8426a04cc01b52b246b8a8e01d168356.woff')
        format('woff'),
      url('//db.onlinewebfonts.com/t/8426a04cc01b52b246b8a8e01d168356.ttf')
        format('truetype'),
      url('//db.onlinewebfonts.com/t/8426a04cc01b52b246b8a8e01d168356.svg#Acta Display')
        format('svg');
    font-display: swap;
  }

  /* 리디바탕 */
  @font-face {
    font-family: 'RIDIBatang';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.0/RIDIBatang.woff')
      format('woff');
    font-display: swap;
  }

  /* D2 코딩 */
  @font-face {
    font-family: 'D2Coding';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_three@1.0/D2Coding.woff')
      format('woff');
    font-display: swap;
  }

  /* 빙그레 볼드 */
  @font-face {
    font-family: 'Binggrae-Bold';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_one@1.0/Binggrae-Bold.woff')
      format('woff');
    font-display: swap;
  }

  /* 조선일보 명조체 */
  @font-face {
    font-family: 'Chosunilbo_myungjo';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_one@1.0/Chosunilbo_myungjo.woff')
      format('woff');
    font-display: swap;
  }

  /* 빛의 계승자체 Bold */
  @font-face {
    font-family: 'HeirofLight';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-07@1.0/HeirofLightBold.woff')
      format('woff');
    font-weight: 700;
    font-style: bold;
    font-display: swap;
  }

  /* 빛의 계승자체 Regular */
  @font-face {
    font-family: 'HeirofLight';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-07@1.0/HeirofLightRegular.woff')
      format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  /* Pretendard */
  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Thin.woff2')
      format('woff2');
    font-weight: 100;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-ExtraLight.woff2')
      format('woff2');
    font-weight: 200;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Light.woff2')
      format('woff2');
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Regular.woff2')
      format('woff2');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Medium.woff2')
      format('woff2');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-SemiBold.woff2')
      format('woff2');
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Bold.woff2')
      format('woff2');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-ExtraBold.woff2')
      format('woff2');
    font-weight: 800;
    font-display: swap;
  }

  @font-face {
    font-family: 'Pretendard';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Black.woff2')
      format('woff2');
    font-weight: 900;
    font-display: swap;
  }

  /* 지마켓 산스 라이트 */
  @font-face {
    font-family: 'GmarketSansLight';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansLight.woff')
      format('woff');
    font-display: swap;
  }

  /* 지마켓 산스 볼드 */
  @font-face {
    font-family: 'GmarketSansBold';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansBold.woff')
      format('woff');
    font-display: swap;
  }

  /* 공고딕 (이사만루체) */
  @font-face {
    font-family: 'GongGothic';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-10@1.0/GongGothicLight.woff')
      format('woff');
    font-display: swap;
  }

  /* 조선신명조 */
  @font-face {
    font-family: 'ChosunSm';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@1.1/ChosunSm.woff')
      format('woff');
    font-display: swap;
  }

  /* 마비노기 옛체 */
  @font-face {
    font-family: 'MabinogiClassic';
    src: url('https://cdn.jsdelivr.net/gh/ginnayang/fonts/Mabinogi_Classic_OTF.otf')
      format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  /* 조선굴림체 */
  @font-face {
    font-family: 'ChosunGu';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@1.0/ChosunGu.woff')
      format('woff');
    font-display: swap;
  }

  /* 갈무리11 */
  @font-face {
    font-family: 'Galmuri11';
    src: url('https://cdn.jsdelivr.net/gh/yangjinhwa/myhome@main/Galmuri11.woff2')
      format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  /* 갈무리9 */
  @font-face {
    font-family: 'Galmuri9';
    src: url('https://cdn.jsdelivr.net/gh/yangjinhwa/myhome@main/Galmuri9.woff2')
      format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  /* 둥근모꼴 */
  @font-face {
    font-family: 'DungGeunMo';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/DungGeunMo.woff')
      format('woff');
    font-display: swap;
  }

  /* a고딕 */
  @font-face {
    font-family: 'Agothic';
    src: url('https://cdn.jsdelivr.net/gh/ginnayang/fonts/a_gothic_11.woff2')
      format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Agothic';
    font-weight: 700;
    font-style: normal;
    src: url('https://cdn.jsdelivr.net/gh/ginnayang/fonts/a_gothic_17.woff2')
      format('woff2');
    font-display: swap;
  }

  /* 아네모네 에어 */
  @font-face {
    font-family: 'Cafe24OhsquareAir';
    src: url('https://cdn.jsdelivr.net/gh/ginnayang/fonts/Cafe24OhsquareAir-v2.0.woff2')
        format('woff2'),
      url('https://cdn.jsdelivr.net/gh/ginnayang/fonts/Cafe24OhsquareAir-v2.0.woff')
        format('woff');
    font-display: swap;
  }

  /* 넥슨 워헤이븐 Regular */
  @font-face {
    font-family: 'Warhaven';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2312-1@1.1/WarhavenR.woff2')
      format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  /* 넥슨 워헤이븐 Bold */
  @font-face {
    font-family: 'Warhaven';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2312-1@1.1/WarhavenB.woff2')
      format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  /* 넥슨 메이플스토리 Bold */
  @font-face {
    font-family: 'MaplestoryOTFBold';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@2.1/MaplestoryOTFBold.woff')
      format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

export default Fontface;
